import { Component, input } from '@angular/core';
import { IonSpinner } from '@ionic/angular/standalone';

@Component({
  selector: 'x-spinner',
  imports: [IonSpinner],
  templateUrl: './x-spinner.component.html',
  styleUrl: './x-spinner.component.scss',
})
export class XSpinnerComponent {
  name = input<string>('crescent');
  cssClass = input<string>('');
}
